import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllLead() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers?page=${page}&limit=${limit}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};

async function FetchAllLeadByDep() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPaginationByDep(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany?page=${page}&limit=${limit}`, { headers });
        return response.data.items
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadSearchByDep(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPaginationSearchByDep(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data.items
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadBycompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCompanyLeads`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByLeadsId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LeadScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchLeadScoreByLeadId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LeadSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createLeads`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLeads/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadConnectioncheck(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/findLeadConnections`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadMergerUpadet(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLeadsInMerge/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function mergeLeadDelte(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteLeadsInMerger`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateLead(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/massUpdateLead`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteLeads(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteLeads`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function convertLeadToContact(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/convertLeadToContact`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    convertLeadToContact,
    massUpdateLead,
    massDeleteLeads,
    LeadConnectioncheck,
    LeadDetailData,
    LeadSave,
    LeadUpdate,
    LeadScoreData,
    FetchAllLeadBycompany,
    LeadMergerUpadet,
    mergeLeadDelte,
    FetchAllLead,
    AllLeadPagination,
    AllLeadPaginationSearch,
    FetchAllLeadSearch,
    FetchAllLeadByDep,
    AllLeadPaginationByDep,
    AllLeadPaginationSearchByDep,
    FetchAllLeadSearchByDep,
}